export const queryKeys = {
  accounts: 'accounts',
  account: 'account',
  advertisers: 'advertisers',
  buyers: 'buyers',
  mediaOwners: 'mediaOwners',
  mediaTypes: 'mediaTypes',
  mediaTypesFlatten: 'mediaTypesFlatten',
  uniqueAdvertisers: 'uniqueAdvertisers',
  uniqueAdvertisersWithBuyer: 'uniqueAdvertisersWithBuyer',
  networks: 'networks',
  languages: 'languages',
  organizationDSPs: 'organizationDSPs',
  externalExchanges: 'externalExchanges',
  demographics: 'demographics',
  userOrganizations: 'userOrganizations',
  userSettings: 'userSettings',
  externalSSPs: 'externalSSPs',
  targetingCriteria: 'targetingCriteria',
  journeys: 'journeys',
  curators: 'curators',
  dataMarketplaces: 'dataMarketplaces',
  dataProviders: 'dataProviders',
};
